import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-handshake-icon',
  templateUrl: './handshake.svg',
  styleUrls: ['./handshake-icon.component.scss'],
})
export class HandshakeIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
